import { IOffer } from 'shared/offer';
import { trackCallbackWidgetOpen } from 'shared/tracking/newbuilding/newbuildingBroker/offerBooking';
import { TThunkAction } from 'shared/types/redux';

import { openNewbuildingBrokerCallbackWidget } from './actions';

export function openNewbuildingBrokerCallbackPopup(offer: IOffer, position: number): TThunkAction<Promise<void>> {
  return async dispatch => {
    const offerInfo = { offer, position };

    dispatch(openNewbuildingBrokerCallbackWidget(offerInfo));
    trackCallbackWidgetOpen(offerInfo);
  };
}
